// extracted by mini-css-extract-plugin
export var breadCrumbIcon = "y_bZ";
export var breadcrumbElement = "y_bV";
export var heroMargins = "y_bY";
export var listBreadcrumb = "y_bX";
export var listBreadcrumbModeDark = "y_bW";
export var listBreadcrumbModeLight = "y_bT";